import { Link } from 'react-router-dom';
import type { Show } from '@/mocks/shows';

interface ShowCardProps {
  show: Show;
  variant?: 'default' | 'compact';
}

export default function ShowCard({ show, variant = 'default' }: ShowCardProps) {
  if (variant === 'compact') {
    return (
      <Link
        to={`/article/${show.id}`}
        className="group block cursor-pointer"
      >
        <div className="relative overflow-hidden rounded-lg aspect-[3/4] bg-background-200">
          <img
            src={show.image}
            alt={`${show.title} - 琪琪影院热门${show.category}`}
            title={`${show.title} ${show.category} 电视剧全集`}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            loading="lazy"
          />
          <div className="absolute top-2 left-2">
            <span className="inline-block px-2 py-0.5 text-xs font-medium bg-primary-500 text-white rounded-md">
              {show.rating}
            </span>
          </div>
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
            <p className="text-white text-xs line-clamp-2">{show.description}</p>
          </div>
        </div>
        <div className="mt-2.5">
          <h3 className="text-sm font-heading font-semibold text-foreground-950 line-clamp-1 group-hover:text-primary-500 transition-colors">
            {show.title}
          </h3>
          <div className="flex items-center gap-2 mt-1">
            <span className="text-xs text-foreground-400">{show.year}</span>
            <span className="text-xs text-foreground-300">·</span>
            <span className="text-xs text-foreground-400">{show.category}</span>
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/article/${show.id}`}
      className="group flex flex-col sm:flex-row gap-4 p-3 rounded-lg hover:bg-background-100 transition-colors cursor-pointer"
    >
      <div className="relative overflow-hidden rounded-lg w-full sm:w-[140px] aspect-[3/4] sm:aspect-[3/4] bg-background-200 shrink-0">
        <img
          src={show.image}
          alt={`${show.title} - 琪琪影院热门${show.category}`}
          title={`${show.title} ${show.category} 电视剧全集`}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute top-2 left-2">
          <span className="inline-block px-2 py-0.5 text-xs font-medium bg-primary-500 text-white rounded-md">
            {show.rating}
          </span>
        </div>
      </div>
      <div className="flex flex-col justify-center flex-1 min-w-0">
        <h3 className="text-base font-heading font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors">
          {show.title}
        </h3>
        <div className="flex items-center flex-wrap gap-1.5 mt-1.5">
          <span className="text-xs text-foreground-400">{show.year}</span>
          <span className="text-xs text-foreground-300">·</span>
          <span className="text-xs text-foreground-400">{show.category}</span>
          <span className="text-xs text-foreground-300">·</span>
          <span className="text-xs text-foreground-400">{show.episodes}集</span>
          <span className="text-xs text-foreground-300">·</span>
          <span className="text-xs text-accent-500 font-medium">{show.status}</span>
        </div>
        <div className="flex flex-wrap gap-1 mt-2">
          {show.genre.map((g) => (
            <span key={g} className="inline-block px-2 py-0.5 text-xs bg-secondary-50 text-secondary-700 rounded-md">
              {g}
            </span>
          ))}
        </div>
        <p className="text-sm text-foreground-500 line-clamp-2 mt-2 hidden sm:block">
          {show.description}
        </p>
      </div>
    </Link>
  );
}